/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: DQL
 * @LastEditTime: 2023-04-17 18:16:04
 * @Description: 消防检测管理服务
 */
/* =============================================
   业务功能路由配置文件引入start
  *
  *
*/
// 检测项目管理
import xmglRoutes from '@/features/xfjcgl/xmgl/xmgl.routes.js';
// 检测报告管理
import bgglRoutes from '@/features/xfjcgl/bggl/bggl.routes.js';
// 检测数据推送管理
import jcsjtsRoutes from '@/features/xfjcgl/jcsjts/jcsjts.routes.js';
// 检测会议管理
import hyglRoutes from '@/features/xfjcgl/hygl/hygl.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [
  xmglRoutes, jcsjtsRoutes, bgglRoutes, hyglRoutes
];

/* 业务功能路由配置写入 End */

// 路由配置=============================================
const xfjcglRoutes = {
  path: 'xfjcgl',
  name: 'xfjcgl',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default xfjcglRoutes;
